export const styles = {
  formContainer: {
    borderBottom: "5px solid #D0E4B6",
    paddingBottom: 2,
  },
  textFieldContainer: {},
  tabsContainer: {
    padding: 0,
    "& .MuiTab-root": {
      fontWeight: "normal",
    },
    "& .Mui-selected": {
      fontWeight: "bold",
    },
  },
  mainContainer: {
    minHeight: "45vh",
    backgroundColor: "white",
    borderRadius: "0 0 5px 5px",
  },
  navHistoryContainer: {
    paddingTop: 0,
  },
  tabPanelContainer: {
    backgroundColor: "white",
    border: "1px solid #E3E3E3",
    padding: 1,
  },
  checkboxContainer: {
    marginTop: 2,
    paddingLeft: 3,
  },
  footerContainer: {
    display: "flex",
    justifyContent: "center",
    marginTop: 2,
    gap: 2,
  },
  buttonContaje: {
    display: "flex",
    justifyContent: "end",
    marginTop: 2,
  },
  navHistoryWrapper: {
    display: "flex",
    flexDirection: "column",
    minHeight: "70vh",
    height: "100%",
    backgroundColor: "#E3E3E3",
    padding: 2,
  },
  navHistoryButton: {
    marginBottom: 1,
  },

  resultsTableContainer: {
    margin: "20px",
    fontFamily: "Arial, sans-serif",
    maxWidth: "600px",
    justifyContent: "center",
    display: "flex",
    gap: "20px",
  },
  resultsTableHeader: {
    fontWeight: "bold",
    marginBottom: "10px",
  },
  resultsTable: {
    borderCollapse: "collapse",
    width: "100%",
  },
  resultsTableCell: {
    padding: "10px",
    border: "1px solid #ddd",
  },
  resultsTableCellLabel: {
    backgroundColor: "#f2f2f2",
    fontWeight: "bold",
  },
  resultsTableCellValue: {
    textAlign: "right",
  },
  newPrepButton: {
    marginTop: "auto",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  modalContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    maxHeight: "80%",
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    px: 4,
    py: 2,
    overflowY: "auto",
  },
};
